import { ADD_ADMIN_TEST, ADD_ADMIN_TESTS, UPDATE_ADMIN_TEST, DELETE_ADMIN_TEST } from './actions';

// Initial State
const initialState = [];

const testReducer = (state = initialState, action) => {
     switch (action.type) {
          case ADD_ADMIN_TEST: {
               const newTestList = [...state];
               newTestList.push(action.payload);

               return newTestList;
          }

          case ADD_ADMIN_TESTS: {
               return action.payload;
          }

          case UPDATE_ADMIN_TEST: {
               const testList = [...state];
               const newTestList = [];

               for (let i = 0; i < testList.length; i++) {
                    const test = testList[i];

                    if (test.id === action.payload.id) {
                         newTestList.push({ ...test, ...action.payload });
                         continue;
                    }

                    newTestList.push(test);
               }

               return newTestList;
          }

          case DELETE_ADMIN_TEST: {
               const testList = [...state];

               return testList.filter((test) => test.id !== action.payload);
          }

          default:
               return state;
     }
};

// Get test by testId
export const getTestById = (state, testId) => state.admin.tests.find((test) => test.id === testId);

export default testReducer;
